import React, { useState, useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    padding: theme.spacing(0, 1, 1, 1),
  },
  tile: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(1, 2),
    minWidth: 110,
    borderTop: "3px solid",
  },
  count: {
    fontWeight: "bold",
    fontSize: "1.3rem",
    lineHeight: 1.2,
  },
  label: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
  },
}));

// Painel com a contagem de contatos por status de validação de WhatsApp,
// atualiza sozinho quando refreshKey muda (ex: depois de validar ou apagar).
const ContactValidationStatsBar = ({ refreshKey }) => {
  const classes = useStyles();
  const [stats, setStats] = useState({ valid: 0, invalid: 0, unchecked: 0 });

  const fetchStats = async () => {
    try {
      const { data } = await api.get("/contacts/validation-stats");
      setStats(data);
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    fetchStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshKey]);

  const tiles = [
    { label: "Válidos", value: stats.valid, color: "#2e7d32" },
    { label: "Inválidos", value: stats.invalid, color: "#c62828" },
    { label: "Não verificados", value: stats.unchecked, color: "#9e9e9e" },
  ];

  return (
    <div className={classes.wrapper}>
      {tiles.map(t => (
        <Paper
          key={t.label}
          variant="outlined"
          className={classes.tile}
          style={{ borderTopColor: t.color }}
        >
          <Typography className={classes.count} style={{ color: t.color }}>
            {t.value}
          </Typography>
          <Typography className={classes.label}>{t.label}</Typography>
        </Paper>
      ))}
    </div>
  );
};

export default ContactValidationStatsBar;
